import styled from 'styled-components';
import PageHeader from './PageHeader';
import { gridSizes } from 'utils/style';

export default styled(PageHeader)`
  height: 72px;
  padding: 3.2rem;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: solid 1px var(--grey-mouse);

  .page-header {
    &__contact-us {
      color: var(--primary500);
    }
  }

  svg {
    fill: var(--primary500);
    height: ${gridSizes('L')};
  }
`;
